<template>
	<transition name="fade-page" mode="out-in">
		<div class="full-sticky-bg"
			:style="{backgroundImage: `url(${photo})`}"
			v-if="isVisible"
		>
			<div class="full-sticky-bg__center">
				<div class="full-sticky-bg__heading">
					<div class="full-sticky-bg__heading__header">{{ addressHeader }}</div>
					<div class="full-sticky-bg__heading__address">{{ addressContent }}</div>
				</div>
				<div class="full-sticky-bg__button-play" v-if="isPlay" @click="onPlay">
					<app-icon name="play-circle" />
				</div>
			</div>

			<div class="full-sticky-bg__button-scroll"
				v-if="isScroll"
				v-scroll-to="{
					el: elToScroll,
					offset: widgets.scrollOffset
				}"
			>
				<app-icon name="arrow-down" />
			</div>	
		</div>
	</transition>
</template>

<script>
	import { mapState, mapGetters, mapActions } from 'vuex'
	import { get, has } from 'lodash'

	import gaMixin from '@/mixins/ga'
	import brandingMixin from '@/mixins/branding'

	import { isTopBanner } from '@/helpers/settings'
	import Icon from '@/components/icon'
	import {isBranded} from "../../helpers/isBranded";

	export default {
		mixins: [gaMixin, brandingMixin],
		components: {
			appIcon: Icon
		},
		props: {
			isPlay: {
				default: false,
				type: Boolean
			}
		},
		data () {
			return {
				photoIndex: 0,
				isVisible: true,
				elToScroll: null
			}
		},
		computed: {
			...mapState('tours', ['address', 'ready', 'settings', 'agent']),
			...mapState('utils', ['widgets']),
			...mapGetters('tours', ['getPhotoByIndex', 'getLayoutType', 'getLayoutName']),
			photo () {
				if (this.ready) {
					if (this.isTopBanner && isBranded()) {
						return get(this.agent.banner, '[0].urls[1].url')
					}

					return this.ready && this.getPhotoByIndex(this.photoIndex).urls[1].url
				}

				return ''
			},
			addressHeader () {
				return this.address.address
			},
			addressContent () {
				const { city, state, zipcode, country } = this.address
				const transformedState = has(state, 'value')
					? state.value + ' '
					: state
						? state + ' '
						: '';

				return `${city}, ${transformedState}${zipcode}, ${country && country.label}`
			},
			isScroll () {
				return this.getLayoutType === 'one' && this.getLayoutName !== 'paper'
			},
			isTopBanner () {
				return isTopBanner(this.settings)
			}
		},
		methods: {
			...mapActions('utils', ['setIsPlay']),
			onPlay () {
				this.isVisible = false

				this.$emit('startPlay')
				this.setIsPlay(true)

				this.sendEventGA('Video', 'Play')
			}
		},
		mounted () {
			this.elToScroll = document.querySelectorAll('.section')[0].className.split(' ').join('.')
		}
	}
</script>

<style lang="scss">
	@import "~@/styles/mixins";

	.full-sticky-bg {
		position: relative;
		display: flex;
		height: 100vh;
		width: 100%;
		background-size: cover;
		background-position: 50% 50%;
		background-color: var(--color-white);
		background-attachment: fixed;
		background-repeat: no-repeat;

		@supports (-webkit-overflow-scrolling: touch) {
			background-attachment: scroll;
		}

		&:before {
			content: '';
			position: absolute;
			width: 100%;
			height: 100%;
			background-color: var(--color-full-sticky-bg);
		}

		&__center {
			position: relative;
			margin: auto;
		}

		&__heading {
			position: relative;
			padding: 0.9375rem;
			text-align: center;
			color: var(--color-full-sticky-bg-heading);

			&__header {
				margin-bottom: 0.625rem;
				font-size: 2.75rem;
				font-weight: 700;
				line-height: 1;
				letter-spacing: 0.1rem;

				@include tablet() {
					font-size: 3.75rem;
				}

				@include desktop() {
					font-size: 4.625rem;
				}
			}

			&__address {
				font-size: 1.375rem;
				font-weight: 300;
				letter-spacing: 0.05rem;

				@include tablet() {
					font-size: 1.5625rem;
				}
			}
		}

		&__button-play {
			display: flex;
			justify-content: center;
			cursor: pointer;
			@include unselectable();

			@include tablet() {
				margin-top: 0.625rem;
			}

			.icon {
				width: 3.75rem;

				@include tablet() {
					width: 6.25rem;
				}

				ellipse, polygon {
					transition: fill .2s ease-out;
				}

				&:hover {
					ellipse {
						fill: var(--color-slideshow-icon-circle-hover);
					}

					polygon {
						fill: var(--color-slideshow-icon-play-hover);
					}
				}
			}
		}

		&__button-scroll {
			position: absolute;
			left: 50%;
			bottom: 3.4375rem;
			width: 2.625rem;
			margin-left: -1.3125rem;
			cursor: pointer;

			@media (min-width : 0px) and (max-width : 767px) and (orientation : landscape) {
				display: none;
			}

			&:hover {
				.icon {
					transform: translateY(0.4375rem);
				}
			}

			.icon {
				width: 100%;
				transition: transform .3s ease-out;

				path {
					fill: var(--color-full-sticky-bg-button);
				}
			}
		}
	}
</style>
